import React from "react";
import AutoScroll from "./AutoScroll";
import ProductCard from "./ProductCard";

export default function ProductCarousel({ id, eyebrow, title, accent, subtext, products, testid, alt = false }) {
  if (!products?.length) return null;
  return (
    <section id={id} data-testid={testid} className={`relative py-12 lg:py-16 ${alt ? "bg-[#F6EEDC]" : ""}`}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal mb-9 text-center">
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{eyebrow}</p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl lg:text-5xl">
            {title} {accent && <span className="text-gold-gradient italic">{accent}</span>}
          </h2>
          {subtext && <p className="font-display mx-auto mt-4 max-w-xl text-lg italic text-[#6B5B45]">{subtext}</p>}
        </div>
        <AutoScroll testid={`${testid}-scroller`} speed={0.8} itemWidth={320}>
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </AutoScroll>
      </div>
    </section>
  );
}
